import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Field, Loader } from "@/components/common";

const cls = "q-input min-h-[44px] w-full";

export default function CoparentJoin() {
  const { token } = useParams();
  const { session } = useAuth();
  const nav = useNavigate();
  const [inv, setInv] = useState(null);
  const [err, setErr] = useState("");
  const [hubId, setHubId] = useState("");
  const [code, setCode] = useState("");
  const [choose, setChoose] = useState(null);
  const [msg, setMsg] = useState("");

  useEffect(() => {
    if (session === false) { sessionStorage.setItem("qhh.returnTo", window.location.pathname); nav("/signin"); return; }
    if (!session) return;
    api.get(`/coparent/invites/${token}`).then(({ data }) => { setInv(data); setHubId(data.hubs[0]?.id || ""); }).catch((e) => setErr(errMsg(e)));
  }, [session, token, nav]);

  const send = (extra = {}) => api.post(`/organizations/${hubId}/coparent/accept`, { token, code, ...extra }).then(({ data }) => {
    if (data.step === "choose") { setChoose(data); setMsg(""); return; }
    toast.success(`${inv.kid_name} is linked`); nav(`/h/${hubId}/coparent?link=${data.link_id}`);
  }).catch((e) => setMsg(errMsg(e)));

  const picked = inv?.hubs.find((h) => h.id === hubId);
  if (err) return <div className="mx-auto max-w-md p-8 text-center"><h1 className="font-display text-2xl font-extrabold text-q-text">Co-parent link</h1><p className="mt-3 text-q-muted" data-testid="cp-join-error">{err}</p></div>;
  if (!inv) return <Loader />;
  return (
    <div className="mx-auto max-w-md space-y-5 p-6 sm:p-10" data-testid="cp-join-page">
      <h1 className="font-display text-3xl font-extrabold text-q-text">Link {inv.kid_name}</h1>
      <p className="text-q-muted">{inv.by_name} from {inv.hub_name} invited you to share {inv.kid_name}'s custody calendar, info, handoff notes and reimbursements. Your money and messages stay private.</p>
      {!inv.hubs.length ? <p className="text-sm text-q-muted" data-testid="cp-join-nohub">Create your own hub first, then open this link again.</p> : !choose ? (
        <div className="space-y-3">
          <Field label="Into your hub"><select className={cls} value={hubId} onChange={(e) => setHubId(e.target.value)} data-testid="cp-join-hub">{inv.hubs.map((h) => <option key={h.id} value={h.id}>{h.name}</option>)}</select></Field>
          {picked && !picked.can_accept && <p className="text-sm font-semibold text-amber-300" data-testid="cp-join-not-parent">Only a parent can accept a co-parent link.</p>}
          <Field label="6-digit code"><input className={cls} inputMode="numeric" maxLength={6} value={code} onChange={(e) => setCode(e.target.value.replace(/\D/g, ""))} data-testid="cp-join-code" /></Field>
          <button className="q-btn q-btn-primary min-h-[44px] w-full" disabled={code.length !== 6 || !picked?.can_accept} onClick={() => send()} data-testid="cp-join-continue">Continue</button>
        </div>
      ) : (
        <div className="space-y-3" data-testid="cp-join-choose">
          <p className="text-sm text-q-text">Is {inv.kid_name} already in your hub?</p>
          {choose.kids.map((k) => <button key={k.id} className="q-btn q-btn-secondary min-h-[44px] w-full" onClick={() => send({ kid_id: k.id })} data-testid={`cp-join-kid-${k.id}`}>Link to {k.name} (merge shared info)</button>)}
          <button className="q-btn q-btn-primary min-h-[44px] w-full" onClick={() => send({ add_new: true })} data-testid="cp-join-add-new">Add {inv.kid_name} to my hub</button>
        </div>
      )}
      {msg && <p className="text-sm font-semibold text-red-400" data-testid="cp-join-msg">{msg}</p>}
    </div>
  );
}
